import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { PostProjectFailure, PostProjectRequest, PostProjectReset, PostProjectSuccess } from './actions';
import { HomeProject } from '@models/swagger';

export const featureKey = 'postProject';

export interface State {
  data: HomeProject | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(PostProjectFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(PostProjectRequest, state => ({ ...state, error: null, loading: true })),
    on(PostProjectSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false })),
    on(PostProjectReset, state => ({ ...state, data: null, error: null, loading: false }))
  )(state, action);
}
